/**
 * EVENTSFLO-ADMIN-BACKUP-UI-COMPONENT-SPLIT-V1
 *
 * Status banner for the SuperAdmin Backups page. Pure presentational —
 * receives `status` + `loading` and renders the same grid V1 rendered.
 * One micro-fix vs V1: `statusData.warning` is now null-safe.
 */
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../../../components/ui/card";
import { AlertTriangle, Shield } from "lucide-react";
import { formatDate } from "./backupFormatters";

export default function BackupStatusCard({ status, loading }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base flex items-center gap-2">
          <Shield className="w-4 h-4" /> System status
        </CardTitle>
      </CardHeader>
      <CardContent>
        {loading ? (
          <div className="text-sm text-zinc-400">Loading status…</div>
        ) : status ? (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
            <div>
              <div className="text-zinc-400">Phase</div>
              <div className="font-medium">{status.phase}</div>
            </div>
            <div>
              <div className="text-zinc-400">DB collections</div>
              <div className="font-medium">{status.database?.collection_count ?? "—"}</div>
            </div>
            <div>
              <div className="text-zinc-400">Approx documents</div>
              <div className="font-medium">
                {(status.database?.approximate_total_documents ?? 0).toLocaleString()}
              </div>
            </div>
            <div>
              <div className="text-zinc-400">Last backup</div>
              <div className="font-medium">{formatDate(status.last_backup_at)}</div>
            </div>
            {status.warning ? (
              <div className="col-span-2 md:col-span-4 text-amber-400 flex items-start gap-2">
                <AlertTriangle className="w-4 h-4 mt-0.5" />
                <div className="text-xs">{status.warning}</div>
              </div>
            ) : null}
            <div className="col-span-2 md:col-span-4 text-xs text-zinc-500">
              Manual export: <span className="text-zinc-300">available</span> &middot; Restore
              preflight + dry-run: <span className="text-zinc-300">available</span> &middot; Live
              restore: <span className="text-red-400">not implemented</span> &middot; Offsite
              backup: <span className="text-red-400">not implemented</span> &middot; Reminder
              automation: <span className="text-red-400">not implemented</span>
            </div>
          </div>
        ) : (
          <div className="text-sm text-red-400">Status unavailable</div>
        )}
      </CardContent>
    </Card>
  );
}
